import { useState } from 'react';
import dynamic from 'next/dynamic';
// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Chip,
  Tooltip,
  Typography,
} from '@mui/material';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// assets
import circleIconMatchingNow from '../../../assets/lottie/circle-icon-matching-now.json';

// Dynamic import Lottie to prevent SSR issues
const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
  loading: () => <span style={{ width: 18, height: 18, display: 'block' }} />
});

// ----------------------------------------------------------------------

const greenTitle = (<Box sx={{ p: 1 }}>
<Typography variant="subtitle2" sx={{ color: 'common.white' }}>
  매칭드릴 수 있는 적합한 회사를 찾고있어요.
</Typography>
<Typography variant="body2" sx={{ color: 'text.disabled', wordBreak: "keep-all" }}>
  매칭이 순차적으로 진행되어 상황에 따라 최대 한 달까지 매칭이 지연될 수 있습니다. <br />
  매칭이 꺼진 것이 아니니 안심하세요.
</Typography>
</Box>);

const yellowTitle = (<Box sx={{ p: 1 }}>
<Typography variant="subtitle2" sx={{ color: 'common.white' }}>
  지금은 매칭이 멈춘 상태에요.
</Typography>
<Typography variant="body2" sx={{ color: 'text.disabled' }}>
  현재 남은 업무 가능 시간이 없으면 매칭은 자동으로 멈춥니다.
</Typography>
</Box>);

const redTitle = (<Box sx={{ p: 1 }}>
  <Typography variant="subtitle2" sx={{ color: 'common.white' }}>
    지금은 매칭이 멈춘 상태에요.
  </Typography>
  <Typography variant="body2" sx={{ color: 'text.disabled' }}>
    프로필 설정 &gt; 알림 &gt; 매칭 제안 받기를 활성화 하시면 매칭이 다시 시작됩니다.
  </Typography>
  </Box>);

export default function MatchingStatusTooltip({ matchAllowed, availableHour }) {
  const [open, setOpen] = useState(false);
  const mdUp = useResponsive('up', 'md');

  const icon = matchAllowed ? (availableHour > 0 ? <GreenCircle /> : <YellowCircle />) : <RedCircle />;
  const title = matchAllowed ? (availableHour > 0 ? greenTitle : yellowTitle) : redTitle;
  const label = matchAllowed ? (availableHour > 0 ? "매칭 진행중" : "매칭 STOP") : "매칭 OFF";

  return (
    <>
    <Tooltip
      title={title}
      placement={mdUp ? "right" : "bottom"}
      arrow
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
    >
      <Chip
        size="small"
        icon={icon}
        label={label}
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          fontFamily: (theme) => theme.typography.overline,
          backgroundColor: (theme) => theme.palette.grey[500_8],
          py: 1.625,
        }}
      />
    </Tooltip>
    </>
  );
}

function GreenCircle ({ sx }) {
  return (
    <Lottie
      animationData={circleIconMatchingNow}
      loop={true}
      style={{
        width: 18,
        height: 18,
        display: 'block',
        marginLeft: '4px',
        marginRight: '-4px',
        ...sx,
      }}
    />
  )
};

const RedCircle = styled('span')(({ theme }) => ({
  height: 16,
  width: 16,
  backgroundColor: theme.palette.error.main,
  borderRadius: '50%',
  display: 'inline-block',
}));

const YellowCircle = styled('span')(({ theme }) => ({
  height: 16,
  width: 16,
  backgroundColor: theme.palette.warning.main,
  borderRadius: '50%',
  display: 'inline-block',
}));
